"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const AcceptInvitationSuccessSceneTranslation = {
    fi: {
        AcceptInvitationSuccessScene: {
            title: 'Salasanasi on tallennettu',
            toLogin: 'Kirjautumissivulle',
            subTitle: 'Tunnuksesi on valmis. Voit nyt kirjautua ohjelmaan.',
        },
    },
    en: {
        AcceptInvitationSuccessScene: {
            title: 'Your password is saved',
            toLogin: 'To Login',
            subTitle: 'Your password is saved. You can now login.',
        },
    },
};
exports.default = AcceptInvitationSuccessSceneTranslation;
//# sourceMappingURL=AcceptInvitationSuccessScene.translation.js.map